// src/services/reportService.js
export const fetchReportData = async (slug) => {
    try {
        const response = await fetch(`https://reports.taiseer.co/api/index.php?slug=${slug}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return transformReportData(data);
    } catch (error) {
        throw error;
    }
};

/* const transformReportData = (data) => {


    const calculateRedeemedGold = (delivered_targets) => {
        if (!delivered_targets || !Array.isArray(delivered_targets)) {
            return 0;
        }
        return delivered_targets.reduce((total, target) => {
            return total + (target.shares_required || 0);
        }, 0) / 1000; // Convert from milligrams to grams
    };
    const {
        basic_info,
        performance_metrics,
        purchase_metrics,
        year_comparison,
        growth_analysis,
        delivered_targets
    } = data;

    return {
        basic_info,
        performance_metrics,
        purchase_metrics,
        year_comparison,
        growth_analysis,
        delivered_targets,

        customerInfo: {
            name: basic_info.name,
            membershipDuration: basic_info.membership_duration,
            startDate: basic_info.start_date
        },

        metrics: {
            totalInvested: purchase_metrics.total_invested,
            totalShares: purchase_metrics.total_shares_acquired,
            currentValue: purchase_metrics.value_breakdown.total_value,
            roiPercentage: purchase_metrics.return_percentage,
            goldHoldings: {
                current: basic_info.current_gold_shares / 1000, // Convert to grams
                redeemed: calculateRedeemedGold(delivered_targets)
            }
        },

        investments: {
            monthly: performance_metrics.monthly_data || [],
            yearlyComparison: year_comparison,
            growth: growth_analysis
        },

        deliveredTargets: delivered_targets.map(target => ({
            ...target,
            delivery_date: target.delivery_date
        })),

        projectedData: {
            initialPrice: purchase_metrics.average_purchase_price_per_gram,
            currentPrice: purchase_metrics.current_gold_price_per_gram,
            monthlyAverage: performance_metrics.investment_summary.average_monthly_investment,
            yearlyGrowthRate: 0.05 // 5% annual growth assumption
        }
    };
}; */

const transformReportData = (data) => {
    const {
        basic_info,
        performance_metrics,
        purchase_metrics,
        year_comparison,
        growth_analysis,
        delivered_targets
    } = data;

    // Calculate redeemed gold correctly
    const redeemedGold = delivered_targets.reduce((total, target) => {
        // Convert string to number and divide by 1000 to get grams
        return total + (Number(target.shares_required) / 1000);
    }, 0);

    return {
        // Keep original data
        basic_info,
        performance_metrics,
        purchase_metrics,
        year_comparison,
        growth_analysis,
        delivered_targets,

        // Transform customer info
        customerInfo: {
            name: basic_info.name,
            membershipDuration: basic_info.membership_duration,
            startDate: basic_info.start_date
        },

        // Transform metrics
        metrics: {
            totalInvested: purchase_metrics.total_invested,
            totalShares: purchase_metrics.total_shares_acquired,
            currentValue: purchase_metrics.value_breakdown.total_value,
            roiPercentage: purchase_metrics.return_percentage,
            goldHoldings: {
                current: Number(basic_info.current_gold_shares) / 1000,
                redeemed: redeemedGold // This should now be correct
            }
        },

        // Rest of the transformations...
        investments: {
            monthly: performance_metrics.monthly_data || [],
            yearlyComparison: year_comparison,
            growth: growth_analysis
        },

        deliveredTargets: delivered_targets,

        projectedData: {
            initialPrice: purchase_metrics.average_purchase_price_per_gram,
            currentPrice: purchase_metrics.current_gold_price_per_gram,
            monthlyAverage: performance_metrics.investment_summary.average_monthly_investment,
            yearlyGrowthRate: 0.05
        }
    };
};